// Loader2Icon has no iconoir equivalent (icon sets don't ship a spinner glyph) - kept as a deliberate exception.
import { Loader2Icon } from 'lucide-react';

import { cn } from '@savgroup-front-common/primitive/lib/utils';

export function Spinner({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
}
